module.exports = __webpack_public_path__ + "static/TypeSetup-5ebfdda0226b893552409d06473f4f3c.png";